import { render } from "./CampaignEventDisplay.vue?vue&type=template&id=561d43de"
import script from "./CampaignEventDisplay.vue?vue&type=script&lang=js"
export * from "./CampaignEventDisplay.vue?vue&type=script&lang=js"

import "./CampaignEventDisplay.vue?vue&type=style&index=0&id=561d43de&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__